package dev.lingvo.shared.ops

import kotlinx.serialization.Serializable

/** A keyset-paginated list whose page size is stated by the server. */
@Serializable
data class OpsPage<T>(
    val rows: List<T>,
    val nextCursor: String? = null,
    val pageSize: Int,
)

/** A bounded window that states its ceiling and whether that ceiling was reached. */
@Serializable
data class OpsWindow<T>(
    val rows: List<T>,
    val cappedAt: Int,
    val hitCap: Boolean,
)
